import axios from "axios";
import { useQuery } from "@tanstack/react-query";

export default function StatusMessage() {
    const { data: statusMessage } = useQuery({
        queryKey: ['status-message'],
        queryFn: getStatusProcessedArticles,
        refetchInterval: 2000,
    })

    async function getStatusProcessedArticles() {
        try {
          const response = await axios.get(
            `${process.env.REACT_APP_BACKEND_URL}/cargar-articulos/get-products-status`,
            {
              headers: {
                Authorization: `Bearer ${
                  JSON.parse(localStorage?.session)?.sessionInfo?.token
                }`,
              },
            }
          );
          if (response.data) {
            return response.data.progress?.message || 'No hay registro de procesamiento';
          }
          return 'No hay registro de procesamiento';
        } catch (error) {
          console.error("Error al obtener el estado de los artículos:", error);
          throw error;
        }
      }

    return (
    <div>
      <h1>{statusMessage || 'Cargando...'}</h1>
    </div>
  );
}